import { enUS, esES } from "@mui/x-data-grid";
import { IntlShape } from "react-intl";

export const getMuiLocaleText = (locale: string, formatMessage: IntlShape["formatMessage"]) => {
  const base = locale.startsWith("es") ? esES : enUS;

  return {
    ...base.components.MuiDataGrid.defaultProps.localeText,
    MuiTablePagination: {
      labelRowsPerPage: formatMessage({ id: "table.rowsPerPage" }),
      labelDisplayedRows: ({ from, to, count }: { from: number; to: number; count: number }) =>
        `${from}–${to} ${formatMessage({ id: "table.of" })} ${count}`,
    },
  };
};
